import React from "react"
import NavBar from "../Components/NavBar"
import "../CSS/workshop_federated.css"
import { FEDERATED } from "../Constants"

let  Workshop_Federated =  () => {
    return (
        <>
            <NavBar></NavBar>
            <h1 className = "roboto-condensed-700" style = {{marginLeft : "3%",marginRight : "3%", borderBottom : "5px solid black", paddingBottom : "2%"}} >International Workshop on Robust Federated Learning on Edge Devices</h1>
            <section className = "speaker-section">
                
                <h2 className = "roboto-condensed-700" >Workshop Chairs</h2>
                <div className = "speakers-workshop">
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Ashish Gupta</h3>
                        <h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus</h4>
                        <p>ashish@dubai.bits-pilani.ac.in</p>
                    </div>
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Rahul Mishra</h3>
                        <h4 className = "roboto-condensed-500">IIT Patna, India</h4>
                        <p>rahul_mishra@iitp.ac.in</p>
                    </div>
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Ashutosh Mishra</h3>
                        <h4 className = "roboto-condensed-500">BITS Pilani, Dubai, UAE</h4>
                        <p>ashutosh@dubai.bits-pilani.ac.in</p>
                    </div>
                </div>

            </section>
            
            
            
            <section style = {{padding : "0"}}className = "federated-learning-important-dates">
                <h2 className = "roboto-condensed-700">Important Dates</h2>
                <div class = "federated-learning-important-dates-items">
                    <div class = "federated-learning-important-dates-item">
                        <p style = {{display : "flex", justifyContent : "center"}}>
                            <p class = "event-date roboto-condensed-700" style = {{textDecoration : "line-through"}}>20<sup>th</sup> AUG 2025</p> 
                            <p class = "event-date roboto-condensed-700" >30<sup>th</sup> AUG 2025</p>
                        </p>
                        <p class = "event-name roboto-condensed-300">Submission of Papers</p>
                    </div>
                    <div class = "federated-learning-important-dates-item">
                        <p class = "event-date roboto-condensed-700">30<sup>th</sup> SEP 2025</p>
                        <p class = "event-name roboto-condensed-300">Acceptance Notification</p>
                    </div>
                    <div class = "federated-learning-important-dates-item">
                        <p class = "event-date roboto-condensed-700">15<sup>th</sup> OCT 2025</p>
                        <p class = "event-name roboto-condensed-300">
                        Camera Ready Paper Deadline</p>
                    </div>
                </div>
            </section>

            <section className = "guidelines-section">
                <h2 className = "roboto-condensed-700">Submission Guidelines</h2>

                <p className = "roboto-300">
                    Authors can submit the paper to workshop clicking <a href = "https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FCINS2025">here</a>. The author
should select track “Workshop on Robust Federated Learning on Edge Devices”.
Accepted, registered and presented papers will be published in the CINS2025 proceedings
and the IEEE Xplore as well as other Abstracting and Indexing (A&I) databases.The length of a submitted
manuscript should not exceed 6 pages (minimum 5 pages) formatted in double-columns. Please visit
the conference website for more information regarding the paper preparation and submission
guidelines (in the Home Tab).
                </p>
            </section>
            
             <a className = "pdf-item" href = {FEDERATED} style = {{textAlign : "center", color : "black", textDecoration : "none"}}><h3 className = "roboto-condensed-700">Click Here for Workshop Call For Paper</h3></a>

        </>
    )
}

export default Workshop_Federated